<template>
  <div>
    <div id="partnership">
      <div class="top">
        <img
          class="returns"
          src="@/assets/img/backleftarrow.png"
          alt=""
          @click="back()"
        />
        <span>合伙人计划</span>
      </div>

      <div class="mid">
        <div class="section-title">合伙人管理</div>

        <div class="manager-section">
          <div class="manager-item">
            <div class="item-title">已邀请</div>
            <div class="item-data">{{ invitationOfMine.invitedPeople }}</div>
          </div>
          <div class="manager-item">
            <div class="item-title">已充值</div>
            <div class="item-data">
              {{ formatNumber(invitationOfMine.paidPeople) }}
            </div>
          </div>
          <div class="manager-item">
            <div class="item-title">已兑换</div>
            <div class="item-data">
              {{ formatNumber(invitationOfMine.paidOutPeople) }}
            </div>
          </div>
        </div>

        <div class="section-title">被邀请用户</div>

        <div class="holdings-section" v-if="partnerShipList.length > 0">
          <div class="holdings-table">
            <!-- 固定列 - 手机号 -->
            <div class="fixed-column" ref="fixedColumn">
              <div class="fixed-header">手机号</div>
              <div class="fixed-content">
                <div
                  class="fixed-cell"
                  v-for="(item, index) in partnerShipList"
                  :key="index"
                >
                  {{ formatterPhone(item.userName) }}
                </div>
              </div>
            </div>

            <!-- 可滚动列 -->
            <div class="scrollable-columns" @scroll="handleTableScroll">
              <!-- 表头 -->
              <div class="scrollable-header">
                <div class="scrollable-header-cell">
                  注册时间
                </div>
                <div class="scrollable-header-cell">
                  当前状态
                </div>
                <!-- <div class="scrollable-header-cell">佣金状态</div> -->
              </div>

              <!-- 数据行 -->
              <div class="scrollable-content">
                <div
                  class="scrollable-row"
                  v-for="(item, index) in partnerShipList"
                  :key="index"
                >
                  <div class="scrollable-cell">
                    {{ item.createTimeStr }}
                  </div>
                  <div class="scrollable-cell">
                    {{ statusMap[item.status] }}
                  </div>
                  <!-- <div class="scrollable-cell">
                    {{ commissionStatusMap[item.commissionStatus]
                    }}{{ formatNumber(item.commissionNum) }}元
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-data" v-else>
          <div class="empty-data-title">暂无数据</div>
          <div class="empty-data-desc">先去邀请用户吧</div>
          <van-button
            style="margin-top: 16px; width: 155px; height: 36px;"
            round
            block
            color="#000"
            type="primary"
            @click="goInvite"
            >邀请用户</van-button
          >
        </div>
      </div>

      <div
        class="bottom-invite"
        v-if="partnerShipList && partnerShipList.length > 0"
      >
        <van-button round block color="#000" type="primary" @click="goInvite"
          >邀请合伙人</van-button
        >
      </div>
    </div>
    <QRCodePopup
      :visible="qrPopupVisible"
      :url="qrUrl"
      @close="handleQRPopupClose"
    />
  </div>
</template>

<script>
import { islogin, partnershipInfo, userInfoDetail } from "@/api/theApi";
import Vue from "vue";
import { Button, Toast } from "vant";
import QRCodePopup from "@/components/QRCodePopup.vue";
import { getInviteUrlByEnv } from "@/utils/url.js";
Vue.use(Toast);

export default {
  name: "StrategyAnalytics",
  components: {
    [Button.name]: Button,
    QRCodePopup,
  },
  data() {
    return {
      // 登陆状态
      islogin: false,
      partnerShipList: [],
      invitationOfMine: {
        invitedPeople: 0,
        // accruedIncome: 0,
        paidPeople: 0,
        // paidOut: 0,
        paidOutPeople: 0,
      },
      commissionStatusMap: {
        1: "待发放",
        2: "已发放",
      },
      statusMap: {
        1: "已注册",
        2: "已充值",
        3: "已兑换",
      },
      qrUrl: "",
      qrPopupVisible: false,
    };
  },
  async created() {
    await this.initData();
  },
  mounted() {
    this.checkPageHeight();
    window.addEventListener("resize", this.checkPageHeight);
  },
  updated() {
    // 数据更新后重新检测
    this.$nextTick(() => {
      this.checkPageHeight();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkPageHeight);
  },
  methods: {
    async goInvite() {
      try {
        const res = await userInfoDetail();
        if (
          res.code !== 20000 ||
          !res.data ||
          !res.data.userInfo ||
          !res.data.userInfo.inviteCode
        ) {
          Toast.fail("获取邀请码失败");
          return;
        }
        this.qrUrl = `${getInviteUrlByEnv()}?invite_code=${
          res.data.userInfo.inviteCode
        }`;
        this.qrPopupVisible = true;
      } catch (error) {
        Toast.fail("获取邀请码失败");
      }
    },
    handleQRPopupClose() {
      this.qrPopupVisible = false;
      this.qrUrl = "";
    },
    back() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace("/user");
      }
    },
    formatterPhone(phone) {
      // 检查输入是否为字符串，如果不是则转换为字符串
      const phoneStr = typeof phone === "string" ? phone : String(phone);

      // 移除所有非数字字符
      const cleaned = phoneStr.replace(/\D/g, "");

      // 检查手机号长度是否合法
      if (cleaned.length !== 11) {
        return phoneStr; // 如果不是11位，返回原始值或可以抛出错误
      }

      // 将第4-7位替换为星号
      const formatted = cleaned.substring(0, 3) + "****" + cleaned.substring(7);

      return formatted;
    },
    // 处理表格滚动事件
    handleTableScroll(event) {
      const scrollLeft = event.target.scrollLeft;
      const fixedElement = this.$refs.fixedColumn;

      if (fixedElement) {
        if (scrollLeft > 0) {
          fixedElement.classList.add("show-shadow");
        } else {
          fixedElement.classList.remove("show-shadow");
        }
      }
    },
    isPositivePercent(percentStr) {
      if (!percentStr) return false;
      const numValue = parseFloat(percentStr.replace("%", ""));
      return !isNaN(numValue) && numValue > 0;
    },
    // 格式化数字，添加千位分隔符
    formatNumber(num) {
      if (num === null || num === undefined || isNaN(num)) return "0";
      return Number(num).toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
    // 格式化货币
    formatCurrency(num) {
      if (num === null || num === undefined || isNaN(num)) return "0";
      return (
        "¥ " +
        Number(num).toLocaleString("zh-CN", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
      );
    },
    // 格式化百分比
    formatPercent(decimal) {
      if (decimal === null || decimal === undefined || isNaN(decimal))
        return "0%";
      const percent = decimal.toFixed(2);
      return `${decimal > 0 ? "+" : ""}${percent}%`;
    },
    // 格式化盈亏金额
    formatPL(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return "0";
      const formatted = Number(amount).toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return `${amount > 0 ? "+" : ""}${formatted}`;
    },
    async initData() {
      // 登陆是否过期
      const theislogin = await islogin();
      this.islogin = theislogin.login_status;

      if (!theislogin.login_status) {
        Toast.fail("您已退出\n请重新登陆");
        setTimeout(() => {
          this.$router.push({
            path: "/login",
          });
        }, 2000);
      }
      const res = await partnershipInfo();
      if (res.code === 20000) {
        this.partnerShipList = res.data;
        this.invitationOfMine = {
          invitedPeople: this.partnerShipList.length,
          // accruedIncome: this.partnerShipList
          //   .filter((item) => item.commissionStatus === "1")
          //   .reduce((total, item) => total + Number(item.commissionNum), 0), // 累加待发放收益
          // paidOut: this.partnerShipList
          //   .filter((item) => item.commissionStatus === "2")
          //   .reduce((total, item) => total + Number(item.commissionNum), 0), // 累加已发放收益
          paidPeople: this.partnerShipList
            .filter((item) => item.status === "2").length || 0,
          paidOutPeople: this.partnerShipList
            .filter((item) => item.status === "3").length || 0,
        };
      }
    },
    // 检测页面高度是否超出屏幕高度
    checkPageHeight() {
      this.$nextTick(() => {
        // 获取整个页面的实际高度
        const bodyHeight = document.body.scrollHeight;
        // 获取视窗高度
        const viewportHeight = window.innerHeight;

        // 如果页面内容高度超出视窗高度，说明会出现滚动条
        // 这时不需要给 mid 设置固定高度
        this.shouldSetMidHeight = bodyHeight <= viewportHeight;
      });
    },
  },
};
</script>

<style lang="less" scoped>
#partnership {
  height: 100vh;
  background: #f8f8f8;

  .top {
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    & > span {
      font-size: 16px;
      font-weight: 600;
    }

    .returns {
      position: absolute;
      width: 24px;
      left: 16px;
    }
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    line-height: 1.5;
    color: #000;
    position: relative;
  }

  .manager-section {
    display: flex;
    border-radius: 8px;
    padding: 16px;
    background-color: #fff;
    margin-bottom: 24px;
    text-align: center;
    .manager-item {
      flex: 1;
      .item-title {
        font-size: 12px;
        color: #8e8e93;
        line-height: 18px;
      }
      .item-data {
        font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        color: #000;
      }
    }
  }

  .mid {
    padding: 0 16px 16px;
    max-height: calc(100dvh - 134px - env(safe-area-inset-bottom));
    overflow-y: auto;
  }

  .holdings-section {
    background-color: #fff;
    margin-top: 16px;
    padding: 0 16px;
    border-radius: 8px;
  }

  .holdings-table {
    display: flex;
    width: 100%;
    position: relative;

    /* 添加右侧渐变阴影提示可滚动 */
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 20px;
      height: 100%;
      background: linear-gradient(
        to left,
        rgba(255, 255, 255, 0.8),
        transparent
      );
      pointer-events: none;
      z-index: 1;
    }
  }

  .fixed-column {
    width: 80px;
    flex-shrink: 0;
    background: #fff;
    z-index: 2;
    position: relative;
    box-shadow: 10px 0 10px -5px rgba(0, 0, 0, 0.06);

    /* 阴影伪元素 */
    &.show-shadow::after {
      content: "";
      position: absolute;
      top: 0;
      right: -6px;
      width: 6px;
      height: 100%;
      background: linear-gradient(to right, rgba(0, 0, 0, 0.06), transparent);
      pointer-events: none;
      transition: opacity 0.3s ease;
      opacity: 1;
    }
  }

  .fixed-header {
    font-size: 12px;
    color: #00000099;
    padding: 16px 14px 4px 0px;
    line-height: 1.5;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 6px;
    text-align: left;
    height: 41px; /* 固定高度，与 scrollable-header 保持一致 */
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .fixed-content {
    display: flex;
    flex-direction: column;
  }

  .fixed-cell {
    font-size: 12px;
    line-height: 1.5;
    color: #000000;
    font-weight: 600;
    padding: 10px 14px 10px 0;
    text-align: left;
    display: flex;
    align-items: center;
    height: 38px; /* 固定高度，与 scrollable-cell 保持一致 */
    box-sizing: border-box;
  }

  .scrollable-columns {
    flex: 1;
    overflow-x: auto;
    position: relative;

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  }

  .scrollable-header {
    display: flex;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 6px;
    height: 41px;
    box-sizing: border-box;
    align-items: center;
  }

  .scrollable-header-cell {
    flex: 1;
    min-width: 100px;
    font-size: 12px;
    color: #00000099;
    line-height: 1.5;
    text-align: left;
    padding: 0 12px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    
    &:first-child {
      padding-left: 24px;
    }
  }

  .scrollable-content {
    display: flex;
    flex-direction: column;
  }

  .scrollable-row {
    display: flex;
    align-items: center;
    height: 38px;
    box-sizing: border-box;
  }

  .scrollable-cell {
    flex: 1;
    min-width: 100px;
    font-size: 12px;
    line-height: 1.5;
    color: #000;
    text-align: left;
    padding: 0 12px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    
    &:first-child {
      padding-left: 24px;
    }
  }

  .empty-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    padding: 40px 16px;
    border-radius: 8px;
    .empty-data-title {
      margin-bottom: 12px;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
      color: #000;
    }
    .empty-data-desc {
      font-size: 14px;
      color: #00000080;
    }
  }

  .bottom-invite {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 24px;
    background-color: #fff;
    padding-bottom: calc(env(safe-area-inset-bottom) + 16px);
  }
}
</style>
